import { Typography, Grid, Card, Box } from '@mui/material';
import MainTitle from "../muiHome/mainTitle";


import ImagesSliderWithLink from '../muiCommonComponent/imageSliderWithLink';


const SAHSStudentshub=()=>{

  
  
const eventGallery = [
  { img: '/assets/img/SOL/event/event1_mg01.jpg', title: 'Zimbabwe Day Celebration',  link: '/school-of-law/zimbabwe_day_celebration'}, 
  { img: '/assets/img/SOL/event/event1_mg06.jpg', title: 'Partition Day Observance -14 August 2024',  link: '/school-of-law/partition_day_observance_14_august_2024'}, 
  { img: '/assets/img/SOL/event/event1_mg10.jpg', title: 'Induction Programme Deeksha Aarambh 2024 ',  link: '/school-of-law/induction_programme_deeksha_aarambh_2024'}, 
  { img: '/assets/img/SOL/event/event1_mg13.jpg', title: 'Teachers Day Celebration at the Law Department  ',  link: '/school-of-law/teachers_day_celebration_law_department'}, 
  { img: '/assets/img/SOL/event/event1_mg14.jpg', title: 'Constitution Day Celebration - 26th November 2024',  link: '/school-of-law/constitution_day_celebration_26th_november_2024'}, 
  { img: '/assets/img/SOL/event/event1_mg16.jpg', title: 'Report On Human Rights Day Celebration',  link: '/school-of-law/report_human_rights_day_celebration'}, 
  { img: '/assets/img/SOL/event/event1_mg17.jpg', title: 'Bhartiya Bhasha Utsav Celebration',  link: '/school-of-law/bhartiya_bhasha_utsav_celebration'}, 
  { img: '/assets/img/SOL/event/event1_mg19.jpg', title: 'Report On Road Safety Program - Date: 10th January 2025',  link: '/school-of-law/report_road_safety_program_date_10th_january_2025'}, 
  { img: '/assets/img/SOL/event/event1_mg24.jpg', title: 'Consumer Awareness Programme',  link: '/school-of-law/consumer_awareness_programme'}, 
  { img: '/assets/img/SOL/event/event1_mg31.jpg', title: 'Voters Day Celebration At The Law Department',  link: '/school-of-law/voters_day_celebration_law_department'}, 
  { img: '/assets/img/SOL/event/event1_mg33.jpg', title: 'Legal Awareness Camp',  link: '/school-of-law/legal_awareness_camp'}, 
  { img: '/assets/img/SOL/event/event1_mg35.jpg', title: 'Court Visit Report',  link: '/school-of-law/court_visit_report'}, 
  { img: '/assets/img/SOL/event/event1_mg40.jpg', title: 'MVN University Students Excel at Inter-College Sports Competition',  link: '/school-of-law/_students_excel_at_inter_college_sports_competition'}, 
    
  // Add more logo URLs as needed
];



return (
<Grid container spacing={2}>
     
    <Grid item xs={12}>
    <MainTitle title="Student’s Hub" />
    </Grid>

    <Grid item xs={12} sm={12} md={12}>
        <Card
          sx={{
            height: "auto",
            padding: "10px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
            borderRadius: "10px",
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            textAlign="center"
          >
            <img
              alt={"NP"}
              src={"/assets/img/SOL/sol_student_hub.png"}
              sx={{ width: 150, height: 150, marginBottom: 2 }}
            />
          </Box>
        </Card>
      </Grid>
    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    A student's hub functions as the dynamic core of academic life, promoting cooperation, learning, and development. It is a vibrant environment where students get together to exchange ideas, seek advice, and participate in educational activities. The hub embodies the fundamental nature of an educational community, providing resources, assistance, and prospects for individual and intellectual growth. It is a location where students may foster relationships, delve into their hobbies, and uncover their passions. The hub serves as a centre for progress, exploration, and change, embodying the essence of oneness and promoting inclusiveness. Student’s hub serves as focal points for student engagement, collaboration, and assistance, aiming to enhance the overall student experience and promote academic success, personal growth, and well-being across various academic, administrative, and personal domains. 
    <br/><br/>
    </Typography>
    </Grid>
     

      <Grid item xs={12} sm={12} md={12} lg={12} >
          <MainTitle title="Event & News Gallery" />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} >
          <ImagesSliderWithLink imgArr={eventGallery} />
        </Grid>



    </Grid>

    

)
}
export default SAHSStudentshub;